export const SET_POLICY = 'SET_POLICY';
export const SET_POLICY_KIND_INVESTMENT = 'SET_POLICY_KIND_INVESTMENT';

export const mutations = {
    [SET_POLICY](state, payload) {
        state.policy = JSON.parse(JSON.stringify(payload));
    },
    [SET_POLICY_KIND_INVESTMENT](state, payload) {
        state.policyKindInvestment = payload;
    },
};
